module.exports = __webpack_public_path__ + "img/microscope.3b288873.svg";